import { Checkbox } from "@mantine/core";
import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { type IUser } from "src/components/shared/UserList/UserList.types";
import { useDispatch, useSelector } from "src/redux/hooks";
import {
  clearUsersToSendWelcomeEmail,
  setSelectAll,
  toggleUserToSendWelcomeEmail,
} from "src/redux/slices/managementSlice";
import { StyledTd, StyledTr } from "src/styled";

interface Props {
  row: IUser;
}

const UsersRow = ({ row }: Props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isSendingWelcomeEmails, usersToSendWelcomeEmail, selectAll } =
    useSelector(state => state.managementSlice);

  useEffect(() => {
    if (selectAll) toggleUser(true);
    else dispatch(clearUsersToSendWelcomeEmail());
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deps kept as they were; changing them changes when this runs
  }, [selectAll]);

  const handleEditUser = useCallback(
    (userId: string) => {
      navigate(
        `/management/users/edit-user/${userId}` +
          (row.yachtid ? `?yachtid=${row.yachtid}` : "") +
          (row.orgid ? `&orgid=${row.orgid}` : "") +
          (row.userclient ? `&clientid=${row.userclient}` : ""),
      );
      dispatch(clearUsersToSendWelcomeEmail());
      dispatch(setSelectAll(false));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deps kept as they were; changing them changes when this runs
    [navigate, row.orgid, row.yachtid, row.userclient],
  );

  const toggleUser = (staySelected: boolean) => {
    dispatch(
      toggleUserToSendWelcomeEmail({
        userid: row.userid,
        staySelected,
      }),
    );
  };

  return (
    <StyledTr
      hover
      onClick={() => handleEditUser(row.userid)}
      style={{ cursor: "pointer" }}>
      {isSendingWelcomeEmails && (
        <StyledTd
          align="center"
          onClick={e => {
            e.stopPropagation();
            toggleUser(false);
          }}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            {/* FROM W. TOMALA: DO NOT REMOVE ON CHANGE PROP! IT MUST BE AT LEAST EMPTY FN */}
            <Checkbox
              checked={usersToSendWelcomeEmail.includes(row.userid)}
              onChange={() => {}}
            />
          </div>
        </StyledTd>
      )}
      <StyledTd>{row.clientname}</StyledTd>
      <StyledTd center>{row.yachtname}</StyledTd>
      <StyledTd center>{row.firstname}</StyledTd>
      <StyledTd center>{row.surname}</StyledTd>
      <StyledTd center>{row.ref}</StyledTd>
      <StyledTd center>{row.rolename}</StyledTd>
      <StyledTd center>{row.email}</StyledTd>
      <StyledTd center>{row.active}</StyledTd>
    </StyledTr>
  );
};

export default UsersRow;
